import gql from 'graphql-tag';

export const GET_SCRATCH_PLATES_FOR_NOTE_PART_QUERY = gql`
  query GetScratchPlatesForNotePart($ids: [StrictString!]!) @skipAudit @engComponent(name: NOTEBOOK) {
    scratchPlates(ids: $ids) {
      ... on ScratchPlateNode {
        id
        name
        createdAt
        width
        height
        plateSchemaId
        summary {
          wellStates {
            rowIndex
            columnIndex
          }
        }
        inventoryPlate {
          ... on PlateNode {
            id
          }
          ... on InaccessibleInfoNode {
            invalidId
          }
        }
      }
      ... on InaccessibleInfoNode {
        invalidId
      }
    }
  }
`;
